__webpack_require__.p = "/investigations/investigation-app/";